import React from 'react';
import ModalForm from '../components/Modal/ModalForm';
import InputsSection from '../components/Modal/InputsSection';
import InputBoxSkeleton from './InputBoxSkeleton';
import ModalButtonsSkeleton from './ModalButtonsSkeleton';

const EditProfileSkeleton = () => {
  return (
    <ModalForm style={{ marginBottom: '2.5rem' }}>
      <InputsSection>
        <InputBoxSkeleton />
        <InputBoxSkeleton />
      </InputsSection>

      <InputsSection>
        <InputBoxSkeleton style={{ width: '52rem', height: '12rem' }} />
      </InputsSection>
      <ModalButtonsSkeleton />
    </ModalForm>
  );
};

export default EditProfileSkeleton;
